import {
  Body,
  Button,
  Card,
  Col,
  Flex,
  LazyImage,
  Row,
  Shape,
  styled,
} from '@teko/ds-mobile';
import {
  BuildPcNumberStepper,
  ProductName,
  ProductPrice,
} from '@teko/ecommerce';
import { ProductCardProps } from '@teko/types/ecommerce';
import { t } from 'i18n';

interface IProductCard extends ProductCardProps {
  quantity: number;
}

interface Props {
  title?: string;
  products?: IProductCard[];
  icon?: string;
  onClick?: () => void;
  onIncrease?: (sku: string) => void;
  removeItem?: (sku: string) => void;
  onDecrease?: (sku: string, quantity: number) => void;
  setQuantity?: (value: number, sku: string) => void;
}

export const HamperItem = ({
  title,
  products = [],
  icon = '',
  onClick,
  onIncrease,
  onDecrease,
  setQuantity,
  removeItem,
}: Props) => {
  return (
    <StyledCard>
      {title && <Body>{title}</Body>}
      {!products.length && (
        <Row justify="space-between" align="middle" marginTop="s12">
          <Shape border="1px solid border" borderRadius="l" padding="s4">
            <LazyImage
              width={68}
              height={68}
              src={icon}
              border
              borderRadius={8}
              contain
            />
          </Shape>
          <StyledButton onClick={onClick} variant="primary">
            {t('Chọn')}
          </StyledButton>
        </Row>
      )}
      {products?.map((product, index) => {
        return (
          <Flex
            key={product.sku}
            width="100%"
            marginTop="s12"
            direction="row"
            align="center"
          >
            <Shape border="1px solid border" borderRadius="l" padding="s4">
              <LazyImage
                width={68}
                height={68}
                src={product?.imageUrl || icon}
                onClick={(): void => {
                  if (!product) onClick?.();
                }}
                borderRadius={8}
                contain
              />
            </Shape>
            <NameWrapper marginLeft="s16" width="75%">
              {product ? (
                <div>
                  {/*TODO: fix type of Anchor href*/}
                  <Anchor
                    // @ts-ignore
                    href={product.link?.as?.pathname}
                    rel="noreferrer noopener"
                    target="_blank"
                  >
                    <ProductName
                      name={
                        product.name || t('Tên sản phẩm đang được cập nhật')
                      }
                    />
                  </Anchor>
                  <SKU>SKU: {product.sellerSku}</SKU>
                </div>
              ) : (
                <div>{t('Vui lòng chọn sản phẩm')}</div>
              )}

              {product.quantity && (
                <Col>
                  {product && product.price && (
                    <StyledPrice
                      {...{
                        price: product.price.latestPrice,
                        discount: product.price.discountPercent,
                        listedPrice: product.price.supplierRetailPrice,
                      }}
                    />
                  )}
                  {product?.quantity && (
                    <BuildPcNumberStepper
                      onIncrease={() => onIncrease?.(product.sku)}
                      onDecrease={() =>
                        onDecrease?.(product.sku, product.quantity)
                      }
                      setValue={(value) => setQuantity?.(value, product.sku)}
                      value={product.quantity}
                    />
                  )}
                  <StyledRemoveText onClick={() => removeItem?.(product.sku)}>
                    {t('Xoá')}
                  </StyledRemoveText>
                </Col>
              )}
              {index === products.length - 1 && (
                <Flex
                  marginTop="s16"
                  justify="end"
                  align="end"
                  direction="row"
                  width="100%"
                >
                  <StyledButton onClick={onClick} variant="primary">
                    {t('Chọn thêm')}
                  </StyledButton>
                </Flex>
              )}
            </NameWrapper>
          </Flex>
        );
      })}
    </StyledCard>
  );
};

const StyledCard = styled(Card)`
  padding: 1.5rem 1rem;
  margin-bottom: 16px;
  transition: box-shadow 0.2s ease-in-out;
  &:hover {
    box-shadow: 0.1rem 0.1rem 0.5rem 0.1rem rgba(0, 0, 0, 0.08);
  }
`;

const StyledButton = styled(Button)`
  height: 32px;
  padding: 10;
`;

const NameWrapper = styled(Col)`
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  display: flex;
  align-items: start;
  flex-direction: column;
`;

const Anchor = styled.a`
  color: unset;
  text-decoration: unset;
  font-size: 13px;
`;

const SKU = styled.span`
  color: #757575;
  font-size: 12px;
`;

const StyledPrice = styled(ProductPrice)`
  min-height: auto;
  margin: 4px 0px;
`;

const StyledRemoveText = styled(Body)`
  margin-top: 12px;
  color: #1990ff;
  font-weight: 400;
  text-align: center;
`;
